import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, } from "react-router-dom";
import { Col } from "react-bootstrap";
import ShowSkeleton from "../utils/helpers/skeleton";
import { getInfrastructure, editInfrastructure } from "../store/slices/mpd";


const Infrastructure = () => {

  const [isloading, setisLoading] = useState(false);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    totalArea: "",
    totalClassRoom: "",
    classRoomSize: "",
    labs: "",
    internet: "",
    girlToilet: "",
    boysToilet: "",
    youtubeLink: ""
  });

  const getInfo = () => {
    dispatch(getInfrastructure())
      .unwrap()
      .then((response) => {
        setFormData(response?.data || {});
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  useEffect(() => {
    dispatch(getInfrastructure())
      .unwrap()
      .then((response) => {
        setFormData(response.data);
      });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(editInfrastructure(formData))
      .unwrap()
      .then(() => {
        alert("Infrastructure Information Updated");
        getInfo();
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <>

      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Infrastructure</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Infrastructure</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>

        </div>
        <div className="card-body px-24 py-24">
          {isloading ? (
            <Col lg={12} xs={12} md={12} align="center">
              {ShowSkeleton()}
            </Col>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-4 mb-20">
                  <label className="form-label">Total Area</label>
                  <input
                    type="text"
                    className="form-control"
                    name="totalArea" maxLength={100}
                    value={formData.totalArea || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4 mb-20">
                  <label className="form-label">Total Classrooms</label>
                  <input
                    type="text"
                    className="form-control"
                    name="totalClassRoom" maxLength={100}
                    value={formData.totalClassRoom || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-20">
                  <label className="form-label">Classroom Size</label>
                  <input
                    type="text"
                    className="form-control"
                    name="classRoomSize" maxLength={100}
                    value={formData.classRoomSize || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-12 mb-20">
                  <label className="form-label">Labs</label>
                  <textarea
                    className="form-control"
                    rows="3" maxLength={200}
                    name="labs"
                    value={formData.labs || ""}
                    onChange={handleChange}
                  />
                </div>


                <div className="col-md-4 mb-20">
                  <label className="form-label">Internet</label>
                  <input
                    type="text" maxLength={100}
                    className="form-control"
                    name="internet"
                    value={formData.internet || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4 mb-20">
                  <label className="form-label">Girl's Toilet</label>
                  <input
                    type="text"
                    className="form-control" maxLength={30}
                    name="girlToilet"
                    value={formData.girlToilet || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4 mb-20">
                  <label className="form-label">Boy's Toilet</label>
                  <input
                    type="text"
                    className="form-control"
                    name="boysToilet"
                    maxLength={70}
                    value={formData.boysToilet || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-12 mb-20">
                  <label className="form-label">Youtube Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="youtubeLink" placeholder="Enter Youtube Link"
                    maxLength={70}
                    value={formData.youtubeLink || ""}
                    onChange={handleChange}
                  />
                </div>


                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary py-2 px-5"
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default Infrastructure;
